import { _t } from 'app/utils/i18n';
import * as Yup from 'yup';

export const schema = Yup.object().shape({
  report_template: Yup.object()
    .required(_t('err_required'))
    .typeError(_t('err_required')),
  description: Yup.string().when({
    is: (other) => other?.length !== 0,
    then: () => Yup.string().required(_t('err_required')),
  }),
  // sections: Yup.array().when({
  //   is: (other) => other.some((item) => item.title || item.description),
  //   then: ()=>Yup.array()
  //     .of(
  //       Yup.object().shape({
  //         title: Yup.string()
  //           .trim()
  //           .min(
  //             2,
  //             _t('basic:err_min', {
  //               fieldName: _t('basic:title'),
  //               length: 2,
  //             })
  //           )
  //           .max(
  //             500,
  //             _t('basic:err_max', {
  //               fieldName: _t('basic:title'),
  //               length: 500,
  //             })
  //           )
  //           .required(_t('err_required'))
  //           .typeError(_t('err_required')),
  //         description: Yup.string()
  //           .trim()
  //           .min(
  //             2,
  //             _t('basic:err_min', {
  //               fieldName: _t('basic:description'),
  //               length: 2,
  //             })
  //           )
  //           .required(_t('err_required'))
  //           .typeError(_t('err_required')),
  //       })
  //     )
  //     .required(_t('err_required'))
  //     .typeError(_t('err_required')),
  // }),
  email_subject: Yup.mixed().when(['schedule_status'], (other) => {
    if (other?.[0])
      return Yup.string()
        .required(_t('err_required'))
        .min(
          2,
          _t('basic:err_min', {
            fieldName: _t('reports:email_subject'),
            length: 2,
          }),
        )
        .max(
          500,
          _t('basic:err_max', {
            fieldName: _t('reports:email_subject'),
            length: 500,
          }),
        );
  }),
  recipients: Yup.mixed().when(['schedule_status'], (other) => {
    if (other?.[0]) {
      return Yup.array()
        .of(
          Yup.object()
            .shape({
              value: Yup.string().email(_t('basic:correct_email')),
            })
            .required(_t('err_required'))
            .typeError(_t('err_required')),
        )
        .min(1, _t('err_required'))
        .required(_t('err_required'))
        .typeError(_t('err_required'));
    }
    return Yup.mixed().notRequired().nullable();
  }),
  recipients_cc: Yup.mixed().when(['schedule_status'], (other) => {
    if (other?.[0])
      return Yup.array().of(
        Yup.object()
          .shape({
            value: Yup.string().email(_t('basic:correct_email')),
          })
          .required(_t('err_required'))
          .typeError(_t('err_required')),
      );
  }),

  recipients_bcc: Yup.mixed().when(['schedule_status'], (other) => {
    if (other?.[0])
      return Yup.array().of(
        Yup.object()
          .shape({
            value: Yup.string().email(_t('basic:correct_email')),
          })
          .required(_t('err_required'))
          .typeError(_t('err_required')),
      );
  }),

  schedule_description: Yup.mixed().when(['schedule_status'], (other) => {
    if (other?.[0]) {
      return Yup.string()
        .required(_t('err_required'))
        .min(
          2,
          _t('basic:err_min', {
            fieldName: _t('reports:email_body'),
            length: 2,
          }),
        );
    }
  }),

  days: Yup.mixed().when(['schedule_status'], (other) => {
    if (other?.[0])
      return Yup.mixed().when(['intervals'], (other) => {
        return other?.[0] !== 'MONTHLY'
          ? Yup.lazy((value) => {
              return Array.isArray(value)
                ? Yup.array()
                    .of(Yup.string().required(_t('err_required')))
                    .min(
                      1,
                      _t('basic:err_min_items', {
                        fieldName: _t('reports:days_of_Week'),
                        length: 1,
                      }),
                    )
                    .required(_t('err_required'))
                    .typeError(_t('err_required'))
                : Yup.string()
                    .required(_t('err_required'))
                    .typeError(_t('err_required'));
            })
          : Yup.mixed().notRequired().nullable();
      });
    return Yup.mixed().notRequired().nullable();
  }),

  format: Yup.mixed().when(['schedule_status'], (other) => {
    if (other?.[0])
      return Yup.mixed().when((other) => {
        if (other.length === 0)
          return typeof other === 'string'
            ? Yup.string().required(_t('err_required'))
            : Yup.array()
                .min(
                  1,
                  _t('basic:err_min_items', {
                    fieldName: _t('reports:format'),
                    length: 1,
                  }),
                )
                .typeError(_t('err_required'));
      });
  }),

  day_of_month: Yup.lazy(() =>
    Yup.mixed().when(['schedule_status'], (other) => {
      if (other?.[0])
        return Yup.mixed().when(['intervals'], (other) => {
          return other?.[0] === 'MONTHLY'
            ? Yup.object()
                .required(_t('err_required'))
                .typeError(_t('err_required'))
            : undefined;
        });
    }),
  ),

  start_date: Yup.mixed().when(['schedule_status'], (other) => {
    if (other?.[0]) {
      return Yup.string()
        .required(_t('err_required'))
        .typeError(_t('err_required'));
    }
    return Yup.mixed().notRequired().nullable();
  }),
  schedule_status: Yup.boolean(),
});
